module.exports = "../../../../platform/assets/pageMainIcon/icon-zhuangtai-4-red.svg";